/**
 * Racine des appels API.
 * Si REACT_APP_BACKEND_URL est défini (ex. build Docker), on l’utilise.
 * Sinon en dev, chemins relatifs "/api" : même hôte/port que la page (3400),
 * le proxy CRA relaie vers le backend (8400) — fonctionne en localhost, IP LAN ou tunnel.
 */
const raw = process.env.REACT_APP_BACKEND_URL;
const trimmed = raw != null ? String(raw).trim() : '';

export const API = trimmed ? `${trimmed.replace(/\/$/, '')}/api` : '/api';
